<template>
  <div class="report-arrears">
    <div class="totle-content">
      <div class="select-search">
        <div class="select-group">

        </div>
        <div class="button-group">
          <el-select placeholder="请选择房源" :value="selectHouseStr">
            <el-option :value="selectHouseStr">
              <el-tree :data="maintree"
                       :props="defaultProps"
                       highlight-current
                       @node-click="handleNodeClick"
                       ref="tree"></el-tree>
            </el-option>
          </el-select>
          <el-date-picker v-model="value0" type="date" placeholder="开始日期" value-format="yyyy-MM-dd"></el-date-picker>
          <el-date-picker v-model="value1" type="date" placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>

          <!--<el-date-picker v-model="date_value" type="daterange" align="right" unlink-panels range-separator="至"-->
          <!--start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" value-format="yyyy-MM-dd" >-->
          <!--</el-date-picker>-->
          <el-button type="primary" icon="el-icon-search" @click="RoomPower();">搜索</el-button>
          <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
        </div>

      </div>
      <div style="font-size: 14px;color:#409eff"><span>总房间数：{{ammeterData.length}}, </span><span>总用电量：{{allpower.toFixed(2)}}度, </span><span>总公摊电量：{{apportion.toFixed(2)}}度</span></div>

      <div class="table-content">
        <el-table class="table-head" :data="dayData" border>
          <el-table-column align="center" type="index" width="50"></el-table-column>
          <el-table-column align="center" prop="title" label="设备名称" min-width="100"></el-table-column>
          <el-table-column align="center" prop="addr" label="地址"  min-width="250"></el-table-column>
          <el-table-column align="center" prop="pcode" label="设备号"></el-table-column>
          <el-table-column align="center" prop="ccode" label="集中器"></el-table-column>
          <!--<el-table-column align="center" prop="date" label="日期" show-overflow-tooltip></el-table-column>-->
          <el-table-column align="center" prop="initpower" label="月初刻度"></el-table-column>
          <el-table-column align="center" prop="lastpower" label="月末刻度"></el-table-column>
          <el-table-column align="center" prop="apportion" label="公摊电量"></el-table-column>
          <el-table-column align="center" prop="allpower" label="总用电(度)"></el-table-column>
          <el-table-column align="center" prop="price" label="单价(元)"></el-table-column>
          <el-table-column align="center" prop="water" label="水费"></el-table-column>
          <el-table-column align="center" prop="allmoney" label="用电金额(元)"></el-table-column>


          <!--<el-table-column align="center" prop="staydate" label="操作" min-width="50">-->
          <!--<template slot-scope="scope">-->
          <!--<el-button @click="toHouse(scope.$index, arrearsData)" type="text" size="small">查看</el-button>-->
          <!--</template>-->
          <!--</el-table-column>-->
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
  import store from "../store";
  var FileSaver = require('file-saver');

  export default {
    name: "ReportRoom",
    data() {
      return{
        dayData:[],
        defaultProps:"",
        selectHouseStr:"",
        maintree:[],
        value0:"",
        value1:"",
        date_value:"",
        pickerOptions2:"",
        district:"",
        code:"",
        ammeterData:[],
        allpower:0,
        apportion:0

      }
    },
    mounted(){
      this.ChooseHouse();
      this.Ammeter();

    },
    methods:{
      handleNodeClick(data) {
        console.log(data);
        this.district=data.district;
        this.code=data.code;
        this.selectHouseStr=data.addr
      },

      //选择房源
      ChooseHouse(){
        this.$http.get(`${store.state.url}house?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
          .then((res) => {
            if(res.Code==0){
              var housedata = [];
              var data = res.Data;
              for (let i in data) {
                housedata[i] = {
                  label: data[i].Title,
                  addr: data[i].Title,
                  children: [],
                  district: data[i].Districtcode,
                  code: data[i].Code
                };
                if(data[i].Citys!=null){
                  for(let j in data[i].Citys){
                    housedata[i].children[j]={
                      label:data[i].Citys[j].Data.Title,
                      addr: data[i].Citys[j].Data.Addr,
                      children:[],
                      district: data[i].Citys[j].Data.Districtcode,
                      code: data[i].Citys[j].Data.Code
                    };
                    if(data[i].Citys[j].Houses!=null){
                      for(let k in data[i].Citys[j].Houses){
                        housedata[i].children[j].children[k]= {
                          label:data[i].Citys[j].Houses[k].Data.Title,
                          addr: data[i].Citys[j].Houses[k].Data.Addr,
                          children:[],
                          district: data[i].Citys[j].Houses[k].Data.Districtcode,
                          code: data[i].Citys[j].Houses[k].Data.Code
                        };
                        if(data[i].Citys[j].Houses[k].Houses!=null) {
                          for (let p in data[i].Citys[j].Houses[p]) {
                            housedata[i].children[j].children[k].children[p] = {
                              label: data[i].Citys[j].Houses[k].Houses[p].Data.Title,
                              addr: data[i].Citys[j].Houses[k].Houses[p].Data.Addr,
                              children: [],
                              district: data[i].Citys[j].Houses[k].Houses[p].Data.Districtcode,
                              code: data[i].Citys[j].Houses[k].Houses[p].Data.Code
                            };
                            if(data[i].Citys[j].Houses[k].Houses[p]!=null) {
                              for (let q in data[i].Citys[j].Houses[p].Houses) {
                                housedata[i].children[j].children[k].children[p].children[q] = {
                                  label: data[i].Citys[j].Houses[k].Houses[p].Houses[q].Data.Title,
                                  addr: data[i].Citys[j].Houses[k].Houses[p].Houses[q].Data.Addr,
                                  children: [],
                                  district: data[i].Citys[j].Houses[k].Houses[p].Houses[q].Data.Districtcode,
                                  code: data[i].Citys[j].Houses[k].Houses[p].Houses[q].Data.Code
                                };

                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            this.maintree = housedata;
          })
      },


      //电表数据
      Ammeter(){
        this.$http.get(`${store.state.url}device/ammeter?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
          .then((res) => {
            if(res.Data!=undefined) {
              for (var i = 0; i < res.Data.length; i++) {
                if (res.Data[i].Devno == 9) {
                  if (res.Data[i].Virtual == 0 || res.Data[i].Virtual == 1) {
                    this.ammeterData.push(res.Data[i])
                  }
                }
              }
            }else{
              this.$message("数据加载失败，请刷新重试");
            }
          });
      },

      //房间用电信息
      RoomPower(){
        // var begin_date = this.date_value[0];
        // var end_date = this.date_value[1];

        var ammeterdata=this.ammeterdata;
        if(ammeterdata.length==0){
          this.$message("数据加载失败，请刷新重试");
        }else {
          console.log(ammeterdata)
          this.$http.get(`${store.state.url}device/ammeter/addup/monthuserid/${window.localStorage.userid}/${this.value0}/${this.value1}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
            .then((res) => {
              if (res.Code == 0) {

                for (var i in ammeterdata) {
                  if (ammeterdata[i].Addr.indexOf(this.selectHouseStr) > -1) {

                    for (var j in res.Data) {
                      if (res.Data[j].devid == ammeterdata[i].Uuid) {
                        var daypower = {
                          title: ammeterdata[i].Title,
                          addr: ammeterdata[i].Addr,
                          pcode: ammeterdata[i].Pcode,
                          ccode: ammeterdata[i].Ccode,
                          initpower: res.Data[j].initpower,
                          lastpower: res.Data[j].lastpower,
                          apportion: res.Data[j].monthapportion,
                          allpower: res.Data[j].monthpower.toFixed(2),
                          price: res.Data[j].price,
                          water: res.Data[j].waterpower,
                          allmoney: (res.Data[j].monthpower * res.Data[j].price).toFixed(2),
                        }
                        this.dayData.push(daypower);
                        this.allpower += res.Data[j].monthpower;
                        this.apportion += daypower.apportion;
                      }
                    }
                  }
                }
              } else {
                this.dayData = [];
                this.$message(res.Message);
              }
            })
        }
      },

      //导出excel
      downloadMater (){
        const defaultCellStyle =  { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};
        const wopts = { bookType:'xlsx', bookSST:false, type:'binary', defaultCellStyle: defaultCellStyle, showGridLines: false};
        const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };

        let Data=[];
        for(let i in this.dayData){
          Data[i] = {
            设备名称: this.dayData[i].title,
            地址: this.dayData[i].addr,
            设备号: this.dayData[i].pcode,
            集中器: this.dayData[i].ccode,
            月初刻度: this.dayData[i].initpower,
            月末刻度: this.dayData[i].lastpower,
            公摊电量: this.dayData[i].apportion,
            总用电: this.dayData[i].allpower,
            单价: this.dayData[i].price,
            水费: this.dayData[i].water,
            用电金额: this.dayData[i].allmoney,
          };
        }
        let data = Data;
        wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

        //创建二进制对象写入转换好的字节流
        let tmpDown =  new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" })
        FileSaver.saveAs(tmpDown, "房间每日用电.xls");
      },
      //字符串转字符流
      s2ab (s) {
        if (typeof ArrayBuffer !== 'undefined') {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        } else {
          var buf = new Array(s.length);
          for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        }
      },

      toHouse(index, row) {
        let devid = row[index].devid,
          tableInfo = {};
        window.localStorage.devid = devid;
        tableInfo.table = 1;
        tableInfo.index = '4';
        store.commit('assignReportPreTableTab', tableInfo);
        this.$router.push('./house');
      }
    }
  }
</script>

<style scoped>
  .button-group{
    /*margin-right:5px;*/
  }

  .button-group .el-date-editor{
    margin-left:10px;
  }
  .button-group .el-button{
    margin-left:10px;
  }

  .el-select{
    width:2.5rem
  }

  .el-select-dropdown__item {
    height: 2.5rem;
    overflow-y: scroll;
  }

  li.el-select-dropdown__item.hover {
    background-color: white;
  }
  .el-tree-node__content{
    font-size: 13px;
  }
  .el-form-item .el-select {
    width: 100%;
  }

</style>
